import { fetchPageData } from "../utils/fetch";

export const getCourses = async () => {
  const endpoint = "courses";
  const method = "GET";
  const err = "Failed to fetch courses.";
  const fetchedData = await fetchPageData(endpoint, method, err);
  return fetchedData;
};

export const updateCourse = async (token, courseId, courseData) => {
  const endpoint = courseId ? `course/${courseId}` : "course";
  const err = courseId ? "Editing course failed." : "Creating course failed.";
  const method = courseId ? "PUT" : "POST";
  const fetchedData = await fetchPageData(
    endpoint,
    method,
    err,
    token,
    courseData
  );
  return fetchedData;
};

export const deleteCourse = async (token, courseId) => {
  const endpoint = `course/${courseId}`;
  const method = "DELETE";
  const err = "Deleting course failed.";
  const fetchedData = await fetchPageData(endpoint, method, err, token);
  return fetchedData;
};
